import { render } from "./CertificateButton.vue?vue&type=template&id=37572b9b&scoped=true"
import script from "./CertificateButton.vue?vue&type=script&lang=js"
export * from "./CertificateButton.vue?vue&type=script&lang=js"

import "./CertificateButton.vue?vue&type=style&index=0&id=37572b9b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37572b9b"]])

export default __exports__